import React from 'react';
import { STYLES } from '../../consts';

interface IProps {
    children: React.ReactNode;
    shouldDisableBlockStyles?: boolean;
}

export const FormItemWrapper = ({ children, shouldDisableBlockStyles }: IProps) => <div className={shouldDisableBlockStyles ? STYLES.CREATE_BILL_BODY.FORM_ITEM_WRAPPER_UN_STYLED : STYLES.CREATE_BILL_BODY.FORM_ITEM_WRAPPER}>{children}</div>;
